import { render, staticRenderFns } from "./TxTemplateBlock.vue?vue&type=template&id=0dd66bfe&scoped=true&"
import script from "./TxTemplateBlock.vue?vue&type=script&lang=js&"
export * from "./TxTemplateBlock.vue?vue&type=script&lang=js&"
import style0 from "./TxTemplateBlock.vue?vue&type=style&index=0&id=0dd66bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd66bfe",
  null
  
)

export default component.exports